'use client'

import { useEffect, useState } from "react";
import mainAPI from "../services/main/mainAPI";

export default function CountAllGame() {
    const [gameCount, setGameCount] = useState<number | null>(null);
    const [isLoadingCount, setIsLoadingCount] = useState(false);

    const fetchCount = async () => {
        setIsLoadingCount(true);
        try {
            const res = await mainAPI.countGameExceptGameDefault();
            if (res && typeof (res as { count?: unknown }).count !== "undefined") {
                setGameCount(Number((res as { count: string }).count));
            }
        } catch {
            console.log("Failed to fetch game count");
        } finally {
            setIsLoadingCount(false);
        }
    };

    useEffect(() => {
        fetchCount();
    }, []);

    return (
        <div className="inline-block min-w-44 rounded-xl border border-[#dcdcdc] bg-white px-5 py-4 shadow-sm">
            <p className="text-lg font-normal text-[#4E4E4E]">เกมทั้งหมด</p>
            <p className="mt-1 text-3xl font-bold leading-tight text-[#0092D7]">
                {isLoadingCount ? (
                    <span className="text-3xl text-[#bbb]">...</span>
                ) : gameCount !== null ? (
                    gameCount
                ) : (
                    "-"
                )}
            </p>
        </div>
    );

}